// extracted by mini-css-extract-plugin
module.exports = {"checkboxWrapper":"checkboxWrapper--3J-jO","text":"text--1K2tR","notificationTitle":"notificationTitle--2QaxG"};